/**
 * 处理优惠券活动新增表单数据
 */
export const handleCouponFormData = data => {
  console.log("🚀 ~ handleCouponFormData ~ data:", data);
};
